import { jsxs as _jsxs } from "react/jsx-runtime";
import { TonConnectUIProvider } from 'delab-tonconnect-ui-react';
export const withTonConnect = (component) => () => (_jsxs(TonConnectUIProvider, { manifestUrl: "https://manifests.delab.team/private.txt", walletsListConfiguration: {
        includeWallets: [
            {
                appName: 'dewallet',
                name: 'DeWallet',
                imageUrl: 'https://de-cdn.delab.team/icons/WalletAvatar.png',
                aboutUrl: 'https://wallet.tg/',
                universalLink: 'https://t.me/delabtonbot/wallet?attach=wallet',
                bridgeUrl: 'https://sse-bridge.delab.team/bridge',
                platforms: ['ios', 'android', 'macos', 'windows', 'linux'],
            },
        ],
    }, children: [' ', component()] }));
